//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import SysTypeDrawer from "./modules/SysTypeDrawer";
import { JeecgListMixin } from '@/mixins/JeecgListMixin';
import { queryProjectArchtList } from '@/api/api';
export default {
  name: 'SysTypeList',
  mixins: [JeecgListMixin],
  components: {
    SysTypeDrawer: SysTypeDrawer
  },
  data: function data() {
    return {
      pagePath: '/site/sys/type',
      pageTitle: '站点系统类型',
      // 表头
      columns: [{
        title: '序号',
        dataIndex: '',
        key: 'rowIndex',
        width: 60,
        align: 'center',
        customRender: function customRender(t, r, index) {
          return parseInt(index) + 1;
        }
      }, {
        dataIndex: 'code',
        colName: 'code',
        title: '编号',
        align: 'center',
        sorter: true
      }, {
        dataIndex: 'name',
        colName: 'name',
        title: '名称',
        align: 'center',
        sorter: true
      }, {
        dataIndex: 'abbreviation',
        colName: 'abbreviation',
        title: '简称',
        align: 'center',
        sorter: true
      }, {
        dataIndex: 'category_dictText',
        colName: 'category',
        title: '监测类型',
        align: 'center',
        sorter: true
      }, {
        dataIndex: 'status_dictText',
        colName: 'status',
        title: '状态',
        align: 'center',
        sorter: true
      }, {
        dataIndex: 'sort',
        colName: 'sort',
        title: '排序号',
        align: 'center',
        sorter: true
      }, {
        title: '操作',
        dataIndex: 'action',
        align: 'center',
        width: 120,
        scopedSlots: {
          customRender: 'action'
        }
      }]
    };
  },
  created: function created() {},
  computed: {},
  methods: {}
};